package com.eladfinish.bible.contest.data.common

import kotlinx.browser.document
import org.w3c.dom.HTMLAnchorElement
import org.w3c.dom.url.URL
import org.w3c.files.Blob
import org.w3c.files.BlobPropertyBag

/**
 * Triggers a browser download of [bytes] as [fileName] (the web equivalent of writing a file to
 * the Documents/Downloads folder on Android/iOS) and returns the object URL, kept alive
 * (not revoked) so it can be reopened later, e.g. via `window.open(url)`.
 */
fun downloadBytesAsFile(bytes: ByteArray, fileName: String, mimeType: String): String {
    val blob = Blob(arrayOf(bytes.unsafeCast<org.khronos.webgl.Int8Array>()), BlobPropertyBag(type = mimeType))
    val url = URL.createObjectURL(blob)
    val anchor = (document.createElement("a") as HTMLAnchorElement).apply {
        href = url
        setAttribute("download", fileName)
    }
    document.body?.appendChild(anchor)
    anchor.click()
    anchor.remove()
    return url
}
